import { render, staticRenderFns } from "./ShareFeedBack.vue?vue&type=template&id=749c3b6d&"
import script from "./ShareFeedBack.vue?vue&type=script&lang=ts&"
export * from "./ShareFeedBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports